var _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53426 1.92842C7.55287 1.77159 7.78046 1.77159 7.79907 1.92842L8.10852 4.53647C8.32633 6.37217 9.77366 7.81951 11.6094 8.03731L14.2174 8.34676C14.3742 8.36537 14.3742 8.59296 14.2174 8.61157L11.6094 8.92102C9.77366 9.13883 8.32633 10.5862 8.10852 12.4219L7.79907 15.0299C7.78046 15.1867 7.55287 15.1867 7.53426 15.0299L7.22481 12.4219C7.00701 10.5862 5.55967 9.13883 3.72397 8.92102L1.11592 8.61157C0.959087 8.59296 0.959087 8.36537 1.11592 8.34676L3.72397 8.03731C5.55967 7.81951 7.00701 6.37217 7.22481 4.53647L7.53426 1.92842Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.25,
    y1: 3.22949,
    x2: 15.9167,
    y2: 3.22949,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 13.5,
    y1: 5.47949,
    x2: 13.5,
    y2: 0.812825,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAvatar);
export default __webpack_public_path__ + "static/media/chat-avatar.b97a4216576d6553a97d93a9ea930c5b.svg";
export { ForwardRef as ReactComponent };